import { Card } from "../ui/Card.jsx";
import { SectionHeading } from "../ui/SectionHeading.jsx";
import { Icon } from "../ui/Icon.jsx";
import { INDUSTRIES } from "./HeroMock.jsx";

export function Stack({ activeIndustry }) {
  const active = INDUSTRIES[activeIndustry];

  return (
    <section className="section" id="stack">
      <div className="container">
        <SectionHeading eyebrow="Your stack" title="No migration. No rip and replace." />
        <div className="stack-grid">
          {active.stack.map((s, i) => {
            const TileIcon = Icon[s.icon];
            return (
              <Card key={i} className="stack-tile" data-reveal>
                <div className="icon-tile icon-tile-accent icon-tile-md"><TileIcon /></div>
                <div className="stack-tile-name">{s.name}</div>
                <div className="stack-tile-kind">{s.kind}</div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
